<template>
  <div>
    <el-card class="login-form-layout">
      <h2 class="login-title color-main">电商后台管理</h2>
      <div>
        <div id="qr_login"></div>
      </div>
    </el-card>
    <img :src="login_center_bg" class="login-center-layout">
  </div>
</template>

<script>
import {setSupport, getSupport, setCookie, getCookie} from '@/utils/support';
import {loginByCode} from '@/api/login';
import login_center_bg from '@/assets/images/login_center_bg.png';

export default {
  name: 'Login',
  data() {
    return {
      loading: false,
      pwdType: 'password',
      login_center_bg,
      dialogVisible: false,
      supportDialogVisible: false
    }
  },
  created() {
    this.init();
    this.replaceWechatRedirectUri();
    this.initCode();
  },
  methods: {
    init() {
      if (this.$route.query.code) {
        this.loading = true;
        loginByCode({code: this.$route.query.code}).then(response => {
          this.$store.dispatch('Login', response.data).then(() => {
            this.loading = false;
            setCookie("username", response.data.username, 15);
            setCookie("password", response.data.password, 15);
            this.$router.push({path: '/'});
          }).catch(() => {
            this.loading = false
          })
        });
      }
    },
    replaceWechatRedirectUri() {
      let url = window.location.href; //获取地址栏路径
      let temp1 = url.split('?');//对url地址进行分割
      debugger
      if (temp1.length == 1) {
        return null;
      }
      let pram = temp1[1];
      let keyValue = pram.split("&");
      if (pram.length == 0) {
        return null;
      }
      let item = keyValue[0].split("=")
      if (item.length == 0) {
        return null;
      }
      let value = item[1];

      return value;
    },
    getCode(code) {
      this.loading = true;
      loginByCode({code: code}).then(response => {
        this.$store.dispatch('Login2', response.data).then(() => {
          this.loading = false;
          // setCookie("username", response.data.username, 15);
          // setCookie("password", response.data.password, 15);
          this.$router.push({path: '/'});
        }).catch(() => {
          this.loading = false
        })
      });
      // return request({
      //   url: '/admin/list',
      //   method: 'get',
      //   code: code
      // })
    },
    handleTry() {
      this.dialogVisible = true
    },
    dialogConfirm() {
      this.dialogVisible = false;
      setSupport(true);
    },
    dialogCancel() {
      this.dialogVisible = false;
      setSupport(false);
    },
    onLoad() {
      this.$router.go(0);
    },
    initCode(){
      if(this.replaceWechatRedirectUri()!=null){
        this.getCode(this.replaceWechatRedirectUri())
      }
    },
  },
  mounted() {
    window.WwLogin({
      id: 'qr_login',
      appid: 'wwb1cef7cdbc0a9188',
      agentid: '1000004',
      redirect_uri: encodeURI('http://niandouyou.xyz/login'),
      state: "niandouyou",
      href: "",
      lang: "zh",
    })
  },
}
</script>


<style scoped>
.login-form-layout {
  position: absolute;
  left: 0;
  right: 0;
  width: 360px;
  margin: 140px auto;
  border-top: 10px solid #409EFF;
}

.login-title {
  text-align: center;
}

.login-center-layout {
  background: #409EFF;
  width: auto;
  height: auto;
  max-width: 100%;
  max-height: 100%;
  margin-top: 200px;
}
</style>



// WEBPACK FOOTER //
// src/views/login/index.vue